import React from "react";
import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate, useParams } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { ThemeProvider } from "@/contexts/ThemeContext";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Waarden from "@/pages/Waarden";
import SprongChecker from "@/pages/SprongChecker";
import Afkortingen from "@/pages/Afkortingen";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword, { VerifyEmail } from "@/pages/ResetPassword";
import MyRoutines from "@/pages/MyRoutines";
import Contact from "@/pages/Contact";
import Documenten from "@/pages/Documenten";
import AdminUsers from "@/pages/AdminUsers";
import { Privacy, Voorwaarden } from "@/pages/Legal";
import Teams from "@/pages/Teams";
import TeamDetail from "@/pages/TeamDetail";
import Vereniging from "@/pages/Vereniging";

function OnderdeelWaarden() { const { onderdeel } = useParams(); return <Waarden onderdeel={onderdeel}/>; }
function OnderdeelChecker() { const { onderdeel } = useParams(); return <SprongChecker onderdeel={onderdeel}/>; }

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login/>}/>
          <Route path="/register" element={<Register/>}/>
          <Route path="/forgot-password" element={<ForgotPassword/>}/>
          <Route path="/reset-password" element={<ResetPassword/>}/>
          <Route path="/verify-email" element={<VerifyEmail/>}/>

          <Route element={<Layout/>}>
            <Route path="/" element={<Home/>}/>
            <Route path="/:onderdeel/waarden" element={<OnderdeelWaarden/>}/>
            <Route path="/:onderdeel/checker" element={<OnderdeelChecker/>}/>
            <Route path="/:onderdeel/afkortingen" element={<Afkortingen/>}/>
            <Route path="/mijn-sprongen" element={<MyRoutines/>}/>
            <Route path="/contact" element={<Contact/>}/>
            <Route path="/regelementen" element={<Documenten/>}/>
            <Route path="/admin/gebruikers" element={<AdminUsers/>}/>
            <Route path="/privacy" element={<Privacy/>}/>
            <Route path="/voorwaarden" element={<Voorwaarden/>}/>
            <Route path="/teams" element={<Teams/>}/>
            <Route path="/teams/:teamId" element={<TeamDetail/>}/>
            <Route path="/vereniging" element={<Vereniging/>}/>
            <Route path="*" element={<Navigate to="/" replace/>}/>
          </Route>
        </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;

